import React from 'react'
import PlanPage from './PlanPage'
import { useLocation } from 'react-router-dom'

export default function PlansPage() {
    const { state } = useLocation()
    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className='layout'>
                            <h5>Plans</h5>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <PlanPage showPlanPage={false} linkData={state} />
                    </div>  
                </div>
            </div>

        </>
    )
}

